import { createSlot } from '@ayocore/platform/client/extensions/createSlot';

/** Настройки карточки счета, регистрируемые инстансом при клиентском bootstrap. */
export const SupplierInvoiceViewExtensions = {
  /** Скрыть блок связей со сделками и не запрашивать его данные. Сами связи не меняются. */
  hideDealLinks: createSlot<void, boolean>(),
};
